import { NgModule } from '@angular/core';
import { SecurePipe } from './secure-file-pipe';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [SecurePipe],
  imports: [CommonModule, IonicModule],
  exports: [SecurePipe],
  providers: [],
})
export class SecurePipeModule {}
